/**
 * Product story video.
 * Loads one Shopify MP4 for the current viewport, and only once the
 * frame is near the screen. Does not autoplay when reduced motion is set.
 */
(function () {
  if (window.__egjStoryAbort) window.__egjStoryAbort.abort();
  if (window.__egjStoryObservers) {
    window.__egjStoryObservers.forEach(function (obs) { obs.disconnect(); });
  }
  window.__egjStoryObservers = [];
  var storyAbort = new AbortController();
  window.__egjStoryAbort = storyAbort;
  var storySignal = storyAbort.signal;

  var roots = document.querySelectorAll('[data-egj-story-video]');
  if (!roots.length) return;

  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function bucket(width) {
    if (width < 750) return 'mobile';
    if (width < 990) return 'square';
    return 'desktop';
  }

  function pickVariant(data, name) {
    var order =
      name === 'mobile'
        ? ['mobile', 'square', 'desktop']
        : name === 'square'
          ? ['square', 'desktop', 'mobile']
          : ['desktop', 'square', 'mobile'];
    for (var i = 0; i < order.length; i += 1) {
      var variant = data[order[i]];
      if (variant && variant.sources && variant.sources.length) return variant;
    }
    return null;
  }

  function pickSource(sources, minWidth) {
    var sorted = sources.slice().sort(function (a, b) {
      return (a.width || 0) - (b.width || 0);
    });
    for (var i = 0; i < sorted.length; i += 1) {
      if ((sorted[i].width || 0) >= minWidth) return sorted[i];
    }
    return sorted[sorted.length - 1];
  }

  function minWidthFor(name) {
    if (name === 'mobile') return 540;
    if (name === 'square') return 720;
    return 1280;
  }

  roots.forEach(function (root) {
    if (root.dataset.egjStoryReady === '1') return;
    root.dataset.egjStoryReady = '1';

    var configNode = root.querySelector('[data-egj-story-config]');
    var stage = root.querySelector('.egj-story-video__stage');
    var frame = root.querySelector('.egj-story-video__frame');
    var video = root.querySelector('video');
    var poster = root.querySelector('[data-egj-story-poster]');
    var playButton = root.querySelector('[data-egj-story-play]');
    var playLabel = root.querySelector('.egj-story-video__center-label');
    var soundButton = root.querySelector('[data-egj-story-sound]');
    var progress = root.querySelector('[data-egj-story-progress]');
    var timeNode = root.querySelector('[data-egj-story-time]');
    if (!configNode || !video || !playButton || !frame || !stage) return;

    var data;
    try {
      data = JSON.parse(configNode.textContent);
    } catch (error) {
      root.hidden = true;
      return;
    }

    var currentKey = '';
    var userStarted = false;
    var scrubbing = false;
    var revealOnly = false;
    var uiTimer = 0;
    var reduced = motionQuery.matches;
    var header = document.querySelector('.section-header');
    var coarse = window.matchMedia('(hover: none)');

    function setPressed(button, pressed) {
      button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    }

    function selectedSource() {
      var key = bucket(window.innerWidth);
      var variant = pickVariant(data, key);
      if (!variant) return null;
      var source = pickSource(variant.sources, minWidthFor(key));
      if (!source || !source.url) return null;
      return { key: key, variant: variant, source: source };
    }

    function paintFrame(selection) {
      currentKey = selection.key;
      root.style.setProperty('--egj-story-ratio', String(selection.variant.aspect || 1.777));
      if (poster && selection.variant.poster) poster.src = selection.variant.poster;
      if (selection.variant.poster) video.setAttribute('poster', selection.variant.poster);
    }

    function mountSource(selection) {
      paintFrame(selection);
      if (video.getAttribute('src') === selection.source.url) return;
      var wasPlaying = !video.paused && !video.ended;
      video.setAttribute('src', selection.source.url);
      video.load();
      if (wasPlaying && !reduced) {
        var playPromise = video.play();
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
      }
    }

    function clock(seconds) {
      var total = Math.max(0, Math.floor(seconds || 0));
      var minutes = Math.floor(total / 60);
      var remain = total % 60;
      return minutes + ':' + (remain < 10 ? '0' : '') + remain;
    }

    function paintTime() {
      if (!timeNode) return;
      var duration = video.duration && isFinite(video.duration) ? video.duration : 0;
      timeNode.textContent = clock(video.currentTime) + (duration ? ' / ' + clock(duration) : '');
      if (!duration) return;
      var ratio = video.currentTime / duration;
      frame.style.setProperty('--egj-story-progress', (ratio * 100).toFixed(2));
      if (progress && !scrubbing) progress.value = String(Math.round(ratio * 1000));
    }

    function showUi(hold) {
      root.classList.add('is-ui');
      clearTimeout(uiTimer);
      if (hold || video.paused || video.ended) return;
      uiTimer = setTimeout(function () {
        root.classList.remove('is-ui');
      }, 2600);
    }

    function syncButtons() {
      var playing = !video.paused && !video.ended;
      var ended = video.ended && video.currentTime > 0;
      if (playLabel) playLabel.textContent = playing ? 'Pause' : ended ? 'Replay' : 'Play';
      playButton.setAttribute(
        'aria-label',
        playing ? 'Pause product video' : ended ? 'Replay product video' : 'Play product video'
      );
      setPressed(playButton, playing);
      root.classList.toggle('is-playing', playing);
      root.classList.toggle('is-ended', ended && !playing);
      if (!soundButton) return;
      soundButton.setAttribute('aria-label', video.muted ? 'Unmute product video' : 'Mute product video');
      setPressed(soundButton, !video.muted);
    }

    function headerBottom() {
      if (!header) return 0;
      var rect = header.getBoundingClientRect();
      return rect.bottom > 0 ? rect.bottom : 0;
    }

    function clearJourney() {
      frame.classList.remove('is-pinned', 'is-parked', 'is-docked');
      frame.style.top = '';
      frame.style.left = '';
      frame.style.width = '';
      frame.style.height = '';
      frame.style.aspectRatio = '';
      stage.style.minHeight = '';
      stage.classList.remove('is-track');
      root.style.setProperty('--egj-story-journey', '0');
    }

    function journeyOn() {
      return window.innerWidth >= 990 && !reduced;
    }

    function lockFrame(height) {
      frame.style.aspectRatio = 'auto';
      frame.style.height = height + 'px';
    }

    function scrubTo(progress) {
      if (userStarted || !journeyOn()) return;
      var selection = selectedSource();
      if (!selection) return;
      if (!video.getAttribute('src')) {
        video.preload = 'auto';
        mountSource(selection);
      }
      if (!video.duration || !isFinite(video.duration)) return;
      if (!video.paused) video.pause();
      var next = Math.min(video.duration, Math.max(0, progress * video.duration));
      if (Math.abs(video.currentTime - next) > 0.045) video.currentTime = next;
    }

    function placeFrame() {
      var gap = 16;
      var top = headerBottom() + gap;
      document.documentElement.style.setProperty('--egj-header-bottom', headerBottom() + 'px');
      if (!journeyOn()) {
        clearJourney();
        return;
      }
      if (!Number(stage.dataset.restHeight)) {
        frame.style.height = '';
        frame.style.aspectRatio = '';
        var measured = frame.offsetHeight;
        if (!measured) return;
        stage.dataset.restHeight = String(measured);
      }
      var height = Number(stage.dataset.restHeight);
      if (!height) return;
      var travel = Math.round(Math.min(420, Math.max(240, window.innerHeight * 0.42)));
      stage.classList.add('is-track');
      stage.style.minHeight = height + travel + 'px';
      var stageRect = stage.getBoundingClientRect();
      var release = stageRect.bottom - height;
      var progress = 0;

      if (stageRect.top >= top) {
        progress = 0;
        frame.classList.remove('is-pinned', 'is-docked');
        frame.classList.add('is-parked');
        frame.style.top = '0px';
        frame.style.left = '0px';
        frame.style.width = '100%';
        lockFrame(height);
      } else if (release > top) {
        progress = Math.min(1, Math.max(0, (top - stageRect.top) / travel));
        frame.classList.remove('is-parked', 'is-docked');
        frame.classList.add('is-pinned');
        frame.style.top = top + 'px';
        frame.style.left = stageRect.left + 'px';
        frame.style.width = stageRect.width + 'px';
        lockFrame(height);
      } else {
        progress = 1;
        frame.classList.remove('is-pinned', 'is-parked');
        frame.classList.add('is-docked');
        frame.style.top = '';
        frame.style.left = '0px';
        frame.style.width = '100%';
        lockFrame(height);
      }

      root.style.setProperty('--egj-story-journey', progress.toFixed(3));
      scrubTo(progress);
    }

    function playFromGesture() {
      userStarted = true;
      var selection = selectedSource();
      if (!selection) return;
      mountSource(selection);
      var playPromise = video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(function () {
          syncButtons();
        });
      }
    }

    playButton.addEventListener('click', function (event) {
      event.stopPropagation();
      if (video.paused || video.ended) playFromGesture();
      else video.pause();
      showUi(video.paused || video.ended);
    });

    frame.addEventListener('pointerdown', function (event) {
      if (event.target.closest('button, input, a')) {
        showUi();
        return;
      }
      if (coarse.matches && !video.paused && !video.ended && !root.classList.contains('is-ui')) {
        revealOnly = true;
        showUi();
      }
    });

    frame.addEventListener('pointermove', function () {
      if (!coarse.matches) showUi();
    });

    frame.addEventListener('click', function (event) {
      if (revealOnly) {
        revealOnly = false;
        return;
      }
      if (event.target.closest('button, input, a')) return;
      if (video.paused || video.ended) playFromGesture();
      else video.pause();
      showUi(video.paused || video.ended);
    });

    if (progress) {
      progress.addEventListener('pointerdown', function () {
        scrubbing = true;
      });
      progress.addEventListener('input', function () {
        userStarted = true;
        if (!video.duration || !isFinite(video.duration)) return;
        video.currentTime = (Number(progress.value) / 1000) * video.duration;
        paintTime();
      });
      progress.addEventListener('change', function () {
        scrubbing = false;
      });
    }

    video.addEventListener('timeupdate', paintTime);
    video.addEventListener('loadedmetadata', paintTime);

    if (soundButton) {
      soundButton.addEventListener('click', function (event) {
        event.stopPropagation();
        video.muted = !video.muted;
        if (video.muted) video.setAttribute('muted', '');
        else video.removeAttribute('muted');
        syncButtons();
        showUi();
      });
    }

    video.addEventListener('play', syncButtons);
    video.addEventListener('pause', syncButtons);
    video.addEventListener('ended', syncButtons);

    if (data.loop) video.loop = true;
    video.muted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.preload = 'none';

    var initial = selectedSource();
    if (!initial) {
      root.hidden = true;
      return;
    }
    paintFrame(initial);
    syncButtons();

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var selection = selectedSource();
            if (!selection) return;
            root.classList.toggle('is-inview', entry.isIntersecting || entry.intersectionRatio > 0);
            if (entry.isIntersecting) {
              if (journeyOn() && !userStarted) {
                video.preload = 'auto';
                mountSource(selection);
                placeFrame();
              } else if (data.autoplay && !reduced && !userStarted) {
                video.preload = 'metadata';
                mountSource(selection);
                var playPromise = video.play();
                if (playPromise && playPromise.catch) playPromise.catch(syncButtons);
              } else if (video.getAttribute('src')) {
                mountSource(selection);
              }
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { rootMargin: '240px 0px', threshold: 0.35 }
      );
      observer.observe(root);
      window.__egjStoryObservers.push(observer);
    }

    var scrollTick = false;
    function onScroll() {
      if (scrollTick) return;
      scrollTick = true;
      window.requestAnimationFrame(function () {
        scrollTick = false;
        document.body.classList.toggle('is-page-scrolled', window.scrollY > 8);
        if (!journeyOn()) {
          if (frame.classList.contains('is-pinned') || frame.classList.contains('is-parked') || frame.classList.contains('is-docked') || stage.style.minHeight) {
            clearJourney();
          }
          return;
        }
        var rect = stage.getBoundingClientRect();
        var near = rect.bottom > -240 && rect.top < window.innerHeight + 480;
        if (!near && !frame.classList.contains('is-pinned')) return;
        placeFrame();
      });
    }
    document.body.classList.toggle('is-page-scrolled', window.scrollY > 8);
    placeFrame();
    window.addEventListener('scroll', onScroll, { passive: true, signal: storySignal });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        delete stage.dataset.restHeight;
        placeFrame();
        var selection = selectedSource();
        if (!selection || selection.key === currentKey) return;
        if (video.getAttribute('src')) mountSource(selection);
        else paintFrame(selection);
      }, 200);
    }, { signal: storySignal });

    if (motionQuery.addEventListener) {
      motionQuery.addEventListener('change', function () {
        reduced = motionQuery.matches;
        if (reduced && !userStarted && !video.paused) video.pause();
        if (reduced) clearJourney();
      }, { signal: storySignal });
    }
  });
})();
